import { render, staticRenderFns } from "./SubscriptionDetails.vue?vue&type=template&id=163691cb&scoped=true"
import script from "./SubscriptionDetails.vue?vue&type=script&lang=ts"
export * from "./SubscriptionDetails.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionDetails.vue?vue&type=style&index=0&id=163691cb&prod&scoped=true&lang=scss"
import style1 from "./SubscriptionDetails.vue?vue&type=style&index=1&id=163691cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163691cb",
  null
  
)

export default component.exports